import { Link } from 'react-router-dom';
import { articleList } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function DeepDiveSection() {
  const featured = articleList.filter((a) => a.isHot).slice(0, 1)[0];
  const sideArticles = articleList.filter((a) => !a.isHot && !a.isExplosive).slice(0, 4);

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-8 md:mb-10 gap-2">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading leading-tight">
            全网追踪<br className="md:hidden" /> 深度起底
          </h2>
          <p className="text-sm text-foreground-500">
            覆盖微博、豆瓣、抖音多平台情报聚合
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5">
          {featured && (
            <div className="lg:col-span-2">
              <ArticleCard
                id={featured.id}
                title={featured.title}
                excerpt={featured.excerpt}
                categoryName={featured.categoryName}
                publishedAt={featured.publishedAt}
                cardImageUrl={featured.cardImageUrl}
                views={featured.views}
                comments={featured.comments}
                isHot={featured.isHot}
                isExplosive={featured.isExplosive}
                variant="featured"
              />
            </div>
          )}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4 md:gap-5">
            {sideArticles.map((article) => (
              <ArticleCard
                key={article.id}
                id={article.id}
                title={article.title}
                excerpt={article.excerpt}
                categoryName={article.categoryName}
                publishedAt={article.publishedAt}
                cardImageUrl={article.cardImageUrl}
                views={article.views}
                comments={article.comments}
                isHot={article.isHot}
                isExplosive={article.isExplosive}
                variant="compact"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}